// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import polyfill from 'babel-polyfill';
import 'url-search-params-polyfill';
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store';

import $ from 'jquery';
import Moment from 'moment';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Cookie from 'js-cookie';
import Print from '@/utils/print'

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(Print) // 注册

window.$ = $;
Vue.prototype.$moment=Moment;
function refresh(to, next, isFromOld = false) {
    let dispatchResult = null;
    if(isFromOld) {
        const matchArray = location.hash.match(/userToken=(.+?)(&|$)/);
        dispatchResult = store.dispatch('FromOldFramework',  matchArray[1]);
        window.sessionStorage.setItem('schoolSignupIsLogin', 1);
    } else {
        const hashToken = location.hash.match(/token=(.+?)(&|$)/);
        if(hashToken && hashToken[1]) {
            Cookie.set('Admin-Token', hashToken[1]);
        }
        dispatchResult = store.dispatch('GetInfo');
    }
    dispatchResult.then(() => { // 拉取user_info
        if (to.meta.permissionPath) {
            if (store.getters.permission.indexOf(to.meta.permissionPath) === -1) {
                next('/404');
            } else {
                next();
            }
        } else {
            next();
        }
    }).catch(error => {
        setTimeout(() => {
            window.location.href = global.command === 'production' ? 'http://www.weixiaojia.cn/wxcepClient/success' : 'http://www.weixiaojia.net/wxcepClient/success';
        }, 1000);
    });
}

router.beforeEach((to, from, next) => {
    const entryList = [
        '/main/primary/notice/noticeList',
        '/main/kindergarten/notice/noticeList'
    ];
    if (entryList.indexOf(to.path) !== -1 && to.query.paramJson && to.query.userToken) {
        if(window.sessionStorage.getItem('schoolSignupIsLogin') != 1) {
            refresh(to, next, true);
        } else {
            if (store.getters.roles.length === 0) { // 判断当前用户是否已拉取完user_info信息
                refresh(to, next);
            } else {
                next();
            }
        }
    } else {

        const whiteList = [
            '/',
            '/kindergarten/outer/outerLogin',
            '/kindergarten/outer/outerNotice',
            '/kindergarten/outer/outerQuestionnaire',
            '/primary/outer/outerLogin',
            '/primary/outer/outerNotice',
            '/primary/outer/outerQuestionnaire',
            '/primary/outer/outerQuestionnaireDetail',
        ];
        console.log(whiteList.indexOf(to.path));
        if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
            next();
        } else {
            if (store.getters.roles.length === 0) { // 判断当前用户是否已拉取完user_info信息
                refresh(to, next);
            } else {
                if (to.meta.permissionPath) {
                    if (store.getters.permission.indexOf(to.meta.permissionPath) === -1) {
                        next('/404');
                    } else {
                        next();
                    }
                } else {
                    next();
                }
            }
        }
    }
});


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>'
});




// WEBPACK FOOTER //
// ./src/main.js